import styled from 'styled-components';

export const Container = styled.div`
  text-align: center;
  color: #161d1f;
  margin: 118px 40px;
  & .image-error {
    display: inline-block;
    width: 360px;
    height: 164px;
    left: -40px;
    position: relative;
    margin-bottom: 16px;
  }
  & .title {
    font-size: 20px;
    line-height: 32px;
    margin-bottom: 16px;
  }

  & .subtitle {
    line-height: 20px;
  }

  & .text {
    margin-bottom: 40px;
  }

  & .button {
    width: 126px;
    height: 44px;
    border-radius: 4px;
    padding: 12px 24px;
    gap: 10px;
  }
  @media (min-width: 640px) {
    margin: 118px 172px;
  }

  @media (min-width: 768px) {
    margin: 144px 208px;
    & .image-error {
      left: 0px;
    }
  }

  @media (min-width: 992px) {
    margin: 148px 176px 148px 264px;
  }

  @media (min-width: 1280px) {
    margin: 208px 368px;
  }

  @media (min-width: 1920px) {
    margin: 208px 684px;
  }
`;
export const Button = styled.button`
  width: Fill (126px);
  height: Hug (44px);
  padding: 12px 24px 12px 24px;
  border-radius: 4px;
  gap: 10px;
  cursor: pointer;
  background: #5b36f2;
  color: #ffffff;
`;
